import { IsProdMode, ISUAT } from "../environment/IsProdMode";

export const EXTERNAL_URL = {

    commonService: {
        dev: "http://192.168.1.32:4072/common",
        prod: "https://api.gyandiksha.in/common",
        uat: "https://api.usk.gujgov.edu.in/common",
    },
    sregService: {
        dev: "http://192.168.1.32:4072/sreg",
        prod: "https://api.gyandiksha.in/sreg",
        uat: "https://api.usk.gujgov.edu.in/sreg",
    },
    appRoot: {
        dev: "http://192.168.1.32:4072",
        prod: "https://api.gyandiksha.in",
        uat: "https://api.usk.gujgov.edu.in",
    },
};
export const getExternalAppUrl = (portal) => {
    if (!portal) return "";

    return ISUAT ? portal.uat : IsProdMode ? portal.prod : portal.dev;
};